import { param } from "jquery";
import moment from "moment";
import { SliderBuilder } from "../../ui/SliderBuilder";

export class EMSConfiserie {
    constructor() {
        this.data_confiserie = null;
    }

    async init(iData) {
        // console.log("EMSConfiserie - init",iData)
        this.data_confiserie = iData.data;
        this.frais_confiserie = iData.frais;
        this.data_cinema = gl_ems_config.data_cinema;
        this.product_image_url = this.data_confiserie.product_image_url;
    }

    select_item(iParam) {
        // console.log("select_item", iParam)
        const self = this;

        var ok=false;
        var data = iParam.data_item;
        var item_type=data.item_type;
        var item_id=data.id;
        var menu_ref=data.menu_ref;
        var tab_products_menu=[];

        // ===== Si on ajoute un menu =====
        if(item_type=="menu"){
            menu_ref=item_id;
            data.menu_ref = menu_ref;
                
            // ===== On va vérifier si c'est un menu avec choix ou non =====
            var is_menu_with_choice=false;
            tab_products_menu=data.products;
            for(var i=0;i<tab_products_menu.length;i++){
                if(tab_products_menu[i].ids.length>1){
                    is_menu_with_choice=true;
                }
                
                // ===== Si menu sans choix, on rajoute le label du/des produits maintenant =====
                if(tab_products_menu[i].ids.length==1){
                    tab_products_menu[i].label=this.data_confiserie.products[tab_products_menu[i].ids].label;
                    tab_products_menu[i].price=this.data_confiserie.products[tab_products_menu[i].ids].price;
                }
            }

            // console.log("is_menu_with_choice",is_menu_with_choice)
            if(is_menu_with_choice){
                let id_menu = data.id;
                this.my_menu_to_compose = {};
                this.my_menu_to_compose.data = data;
                this.my_menu_to_compose.nb_item_tot_selected=0;
                this.my_menu_to_compose.nb_item_tot_to_choose=0;
                this.my_menu_to_compose.tab_item_choosen=[];

                var src_poster_menu;
                if(data.img){
                    src_poster_menu = data.img.replace("/120","/320");
                }else{
                    // src_poster_menu = "https://static.monnaie-services.com/www-img/ticketingcine/default_prd_confiserie.webp";
                    src_poster_menu = "https://static.monnaie-services.com/www-img/ticketingcine/no_img_conf_imsweb.webp";
                }

                let $content=$("<div/>").addClass("");
                    var $row = $("<div/>").addClass("row row_modal_body").appendTo($content);
                        // var $col_selection_item=$("<div/>").addClass("col-12 col-md-9 col-xl-10 p-0 order-2 order-md-1").attr({"id":"col_selection_item"}).appendTo($row);
                        // var $col_recap_selection=$("<div/>").addClass("col-12 col-md-3 col-xl-2 p-0 order-1 order-md-2").attr({"id":"col_recap_selection"}).appendTo($row).css({
                        //     "background-image":"url("+src_poster_menu+")"
                        // });
                        
                        var $col_recap_selection=$("<div/>").addClass("col-12 p-0").attr({"id":"col_recap_selection"}).appendTo($row).css({
                            "background-image":"url("+src_poster_menu+")"
                        });
                            var $row_label_menu=$("<div/>").addClass("row m-0").attr({"id":"row_label_menu"}).appendTo($col_recap_selection);
                                    var $col_label_menu=$("<div/>").addClass("col-12 pt-0 pt-md-2 d-flex position-relative").appendTo($row_label_menu);
                                        var $label_menu=$("<div/>").addClass("h6 text-center bold m-auto").text(data.label).attr({"id":"label_menu"}).appendTo($col_label_menu);

                        var $col_selection_item=$("<div/>").addClass("col-12 p-0").attr({"id":"col_selection_item"}).appendTo($row);

                let indice = 0;
                tab_products_menu.forEach(prds_menu => {
                    var tab_item=prds_menu.ids;
                    var qty_to_choose=prds_menu.qty;
                    var has_product_available=false;
                    var tab_sold_in=[];
                    var tab_sold_out=[];
                    var tab_items_to_slider=[];

                    this.my_menu_to_compose.nb_item_tot_to_choose+=parseInt(qty_to_choose);

                    var $row=$("<div/>").addClass("row mx-0 my-2 row_choice_menu").attr({"id":"row_choice_menu_"+id_menu+"_"+indice}).appendTo($col_selection_item);
                        var $col=$("<div/>").addClass("col-12 p-0 position-relative").attr({"id":"col_choice_menu_"+id_menu+"_"+indice}).appendTo($row); 
                            var $text=$("<div/>").addClass("ps-0 ps-md-4 pt-0 pt-md-2 w-100 title").text(_l("Veuillez sélectionner")+" "+qty_to_choose+" "+_l("article(s) de cette liste")).appendTo($col);

                    for(var j=0;j<tab_item.length;j++){
                        var sold_out=false;
                        var item_id=parseInt(tab_item[j]);
                        var val = null;
                        
                        // ===== Recherche des infos du produits =====
                        $.each(this.data_confiserie.products,function(key,value){
                            if(item_id==key){
                                val=Object.assign({},value);
                                return false; // arrête la boucle
                            }
                        });
                        
                        // ===== Si le cinéma n'autorise pas la vente en stock négatif, on check la liste des soldout =====
                        if(!this.data_confiserie.autorise_vente_negative){
                            if(this.data_confiserie.soldout && this.data_confiserie.soldout.indexOf(item_id)>=0){
                                sold_out=true;
                            }
                        }
                        
                        if(val && val!=null){
                            val.item_type="product";
                            if(sold_out){
                                val.is_sold_out=true;
                                tab_sold_out.push(val);
                            }else{
                                val.is_sold_out=false;
                                tab_sold_in.push(val);
                            }
                        }

                        if(val.img){
                            val.img = this.product_image_url+val.img;
                            val.img = val.img.replace("/120","/240");
                        }else{
                            // val.img = "https://static.monnaie-services.com/www-img/ticketingcine/default_prd_confiserie.webp";
                            val.img = "https://static.monnaie-services.com/www-img/ticketingcine/no_img_conf_imsweb.webp";
                        }

                        // let item_url = val.img ? val.img : "https://static.monnaie-services.com/www-img/ticketingcine/default_prd_confiserie.webp";
                        let item_url = val.img ? val.img : "https://static.monnaie-services.com/www-img/ticketingcine/no_img_conf_imsweb.webp";

                        val.img = item_url;
                    }

                    // ===== Affichage des produits en stock =====
                    for(var j=0;j<tab_sold_in.length;j++){
                        has_product_available=true;
                        tab_items_to_slider.push(tab_sold_in[j]);
                    }

                    // ===== Affichage des produits épuisés =====
                    if(this.data_confiserie.show_soldout){
                        has_product_available=true;
                        for(var j=0;j<tab_sold_out.length;j++){
                            var val=tab_sold_out[j];
                            tab_items_to_slider.push(tab_sold_out[j]);
                        }
                    }

                    if(has_product_available){
                        var $wrap=$("<div/>").addClass("wrap").appendTo($col)

                        const slider_confiserie = new SliderBuilder({
                            indice : indice
                        });
                        const $slider = slider_confiserie.$create().appendTo($wrap);
                        slider_confiserie.$createConfiserieCards(tab_items_to_slider,"compose_menu");
                        
                        var $separator=$("<div/>").addClass("separator").appendTo($wrap);
                    }

                    indice++;
                });

                new MSModal({
                    buttons : [
                        {
                            class : "bg-danger",
                            title : "Annuler",
                            preventClose : false
                        },{
                            class : "bg-success btn_confirm_compo_menu hide",
                            title : "Valider",
                            preventClose : false,
                            action : () => {
                                data.tab_item_choosen = this.my_menu_to_compose.tab_item_choosen;
                                self.add_to_basket({
                                    "data" : data,
                                });
                            },
                        }
                    ],
                    has_close_box : true,
                    html : $content,
                    option : {
                        dialog : {
                            class : "modal-dialog-centered modal-xl modal-dialog-scrollable"
                        },
                        title : {
                            class : "h2"
                        }
                    },
                    title : _l("Composer votre menu"),
                })
                .open();
            }else{
                ok=true;
            }
        }else{
            ok = true;
        }

        if(ok){
            self.add_to_basket({
                "data" : data,
                "elem_from" : iParam.elem_from
            });
        }
    }

    add_to_basket(parameter) {
        gl_app.EMSBasket.add({
            "data_cinema": this.data_cinema,
            "data_item": parameter.data,
            "item_type": parameter.data.item_type,
            "data_confiserie": this.data_confiserie,
            "elem_from" : parameter.elem_from
        });
    }

    remove_to_basket(parameter) {
        gl_app.EMSBasket.remove({
            "data_cinema": this.data_cinema,
            "data_item": parameter.data,
            "item_type": parameter.data.item_type
        });
    }

    animation_add_item_to_cart(parameter) {
        // console.log("animation_add_item_to_cart", parameter)
        var $target = null;
        if(!gl_mobile_app){
            $target=$("nav a#cart");
        }else{
            $target=$(".mobile-app-footer #box_basket");
        }
        var $target_rect=$target[0].getBoundingClientRect();

        // ===== Elément depuis lequel l'animation va démarrer =====
        var $t=parameter.elem_from;

        // ===== Récupération de la position x/y de l'élément sur lequel nous avons cliqué =====
        const rect = $t[0].getBoundingClientRect();

        // ===== Création d'un élément que l'on va faire glisser jusqu'au panier =====
        var src_poster;
        if(parameter.img){
            src_poster=parameter.img;
        }else{
            src_poster="ihttps://static.monnaie-services.com/www-img/ticketingcine/no_img_conf_imsweb.webp";
        }

        var $from=$("<div/>").addClass("rounded").appendTo("html").css({
            "position":"absolute",
            "top":rect.top + window.scrollY,
            "left":rect.left + window.scrollX,
            "height":$t[0].clientHeight,
            "width":$t[0].clientWidth,
            "z-index":10000,
            "background-image":"url("+src_poster+")",
            "background-repeat":"no-repeat",
            "background-position":"center",
            "background-size":"cover",
            "background-color":"white"
        });

        // ===== Animation vers l'élément "target" =====
        $from.animate(
        {
            "top":$target_rect.top + window.scrollY,
            "left":$target_rect.left + window.scrollX,
            "opacity":0,
            "height":0,
            "width":0
        }
        ,1500,function(){
            $(this).remove();
        })
    }

    menu_auto() {
        // console.log("==== confiserie_list.menu_auto =====")
        let id_confiserie_unit = localStorage.getItem("id_confiserie_unit") ? JSON.parse(localStorage.getItem("id_confiserie_unit")) : {};

        // console.log("id_confiserie_unit", id_confiserie_unit)

        let last_menu_to_match;
        let tab_menu_match = [];
        let data_basket = gl_app.EMSBasket.get_data();

        // ================================================
        // ===== Si le cinéma autorise les menus auto =====
        // ================================================
        if (this.data_confiserie.menu_auto_confiserie && this.data_confiserie.menus) {
            // ===== On va récupérer le nombre d'article confiserie en panier (menu et produit) =====
            // ===== Et les retirer à "data_basket.nb_item_total" =====
            $.each(data_basket.confiserie, function (key, val) {
                if (key == "product" || key == "menu") {
                    $.each(data_basket.confiserie[key], function (k, v) {
                        data_basket.nb_item_total -= v.qte;
                    })
                }
            });

            let mode_payment_conf = data_basket.confiserie.mode_payment;
            data_basket.confiserie = {};
            data_basket.confiserie.mode_payment = mode_payment_conf;

            // ===== On parcours chaque menus (conf.json) =====
            $.each(this.data_confiserie.menus, function (key, value) {
                var id_menu = key;
                var val_menu = value;
                var tab_products_menu = value.products;
                var match_menu = true; // Variable pour indiquer que ce menu peut etre ajouté
                var tab_item_choosen = []; // Variable qui contiendra la liste des produits du menu

                // console.log("menu id:"+key, tab_products_menu)

                // ===== On boucle sur chaque composition du menu =====
                var match_compo = false;
                for (var i = 0; i < tab_products_menu.length; i++) {
                    var ids_compo = tab_products_menu[i].ids;
                    var qty_compo = tab_products_menu[i].qty;

                    // ===== Parcours des produits confiserie du panier =====
                    $.each(id_confiserie_unit, function (k, v) {
                        var id_product = v.id;
                        var qty_product = v.qty;

                        if ($.inArray(id_product, ids_compo) >= 0) {
                            match_compo = true;
                            return false;
                        } else {
                            match_compo = false;
                        }
                    });

                    if (!match_compo) {
                        break;
                    }
                }

                if (match_compo) {
                    tab_menu_match.push(val_menu);
                }
            });

            // ===== On tri les potentiels menus par prix =====
            // ===== Le moins élevé sera prioritaire pour prendre les produits =====
            if (tab_menu_match.length > 0) {
                let sorted_menu = tab_menu_match.sort((m1, m2) => (m1.price < m2.price) ? -1 : (m1.price > m2.price) ? 1 : 0);
                // console.log(sorted_menu)
                let product_to_take;
                let at_least_one_menu = false; // si un menu est ok, on continuera la boucle, il peut y avoir plusieurs fois le meme menu
                let nb = 0; // ===== Sécurité pour éviter une potentielle boucle infinie, si un cas n'est pas bien traiter, bouclera max 10 fois =====
                do {
                    nb++;

                    at_least_one_menu = false;
                    for (var sm = 0; sm < sorted_menu.length; sm++) {
                        let menu_ok = false;
                        const product_list = sorted_menu[sm].products;
                        var tab_compo_my_menu = [];
                        let product_deducted = [];
                        let associated_price = [];

                        for (var i = 0; i < product_list.length; i++) {
                            let ids = product_list[i].ids;
                            let qty_p_list = product_list[i].qty;

                            ids.forEach(id_p => {
                                if (id_confiserie_unit[id_p]) {
                                    product_to_take = id_confiserie_unit[id_p];
                                    // console.log("product_to_take : ",product_to_take)

                                    if (qty_p_list > 0 && product_to_take.qty > 0) {
                                        let qte_temp = 0;
                                        if (qty_p_list >= product_to_take.qty) {
                                            qte_temp = product_to_take.qty;
                                            qty_p_list -= product_to_take.qty;
                                        } else {
                                            qte_temp = qty_p_list;
                                            qty_p_list -= qte_temp;
                                        }

                                        tab_compo_my_menu.push({ "ids": [id_p], "qty": qte_temp, "label": this.data_confiserie.products[id_p].label, "price": this.data_confiserie.products[id_p].price });
                                        product_deducted.push({ "ids": [id_p], "qty": qte_temp, "label": this.data_confiserie.products[id_p].label, "price": this.data_confiserie.products[id_p].price });

                                        product_to_take.qty -= qte_temp;

                                        associated_price = product_to_take.associated_price;
                                    }
                                }
                            });

                            // console.log("qty_p_list : ",qty_p_list)
                            // ===== Si la quantité de la composition est supérieure à 0, cela signifie que l'on a pas assez de produit unitaire ====
                            // ===== Ce menu ne pourra pas être ajouté au panier =====
                            // ===== On passe au potentiel menu suivant =====
                            if (qty_p_list > 0) {
                                menu_ok = false;
                                break;
                            } else {
                                menu_ok = true;
                            }
                        };

                        if (menu_ok) {
                            at_least_one_menu = true;
                            var item_type = "menu";
                            var id_menu = sorted_menu[sm].id;
                            var menu_ref = id_menu;

                            if (!data_basket.confiserie.mode_payment) {
                                data_basket.confiserie.mode_payment = "CB";
                            }

                            // ===== Si il n'y a pas déjà un de ce type dans le panier (menu ou product) =====
                            if (!(data_basket.confiserie[item_type])) {
                                data_basket.confiserie[item_type] = {};
                            }

                            // ===== Si il n'y a pas déjà cet id confiserie =====
                            if (!(data_basket.confiserie[item_type][id_menu])) {
                                data_basket.confiserie[item_type][id_menu] = {};

                                data_basket.confiserie[item_type][id_menu].qte = 1;
                                data_basket.confiserie[item_type][id_menu].id = id_menu;
                                data_basket.confiserie[item_type][id_menu].label = this.data_confiserie.menus[id_menu].label;
                                data_basket.confiserie[item_type][id_menu].price = this.data_confiserie.menus[id_menu].price;
                                data_basket.confiserie[item_type][id_menu].is_sold_out = this.data_confiserie.menus[id_menu].is_sold_out;
                                data_basket.confiserie[item_type][id_menu].products = this.data_confiserie.menus[id_menu].products;

                                menu_ref += "-0";

                                data_basket.confiserie[item_type][id_menu].ref_list = {};
                                data_basket.confiserie[item_type][id_menu].ref_list[menu_ref] = {};
                                data_basket.confiserie[item_type][id_menu].ref_list[menu_ref].products = tab_compo_my_menu;   // tableau qui contiendra la liste des produits du menu                             
                            } else {
                                var indice_ref = 0;

                                // ===== On récupère l'incide du dernier menu et on fait +1 =====
                                $.each(data_basket.confiserie[item_type][id_menu].ref_list, function (key, value) {
                                    var tab_ref_list = key.split("-");
                                    indice_ref = parseInt(tab_ref_list[1]);
                                });

                                indice_ref++;

                                menu_ref += "-" + indice_ref;

                                data_basket.confiserie[item_type][id_menu].ref_list[menu_ref] = {};
                                data_basket.confiserie[item_type][id_menu].ref_list[menu_ref].products = tab_compo_my_menu;   // tableau qui contiendra la liste des produits du menu

                                var new_qte = parseInt(data_basket.confiserie[item_type][id_menu].qte) + 1;
                                data_basket.confiserie[item_type][id_menu].qte = new_qte;
                            }

                            // ===== Si l'article a été ajouté suite à l'association à un tarif =====
                            if (associated_price && associated_price.length > 0) {
                                data_basket.confiserie[item_type][id_menu].associated_price = associated_price;
                            };

                            // ===== Mise à jour de la variable qui contient le nombre total d'article dans le panier =====
                            data_basket.nb_item_total++;
                        } else {
                            // ===== On remet les quantité de base que si il reste encore des menus à vérifier =====
                            // ===== Sinon c'est que le dernier menu vient d'être vérifié et que les produits restants =====
                            // ===== N'ont matché aucun menu et seront donc des produits seuls =====
                            for (var i = 0; i < product_deducted.length; i++) {
                                let id_deducted = product_deducted[i].ids[0];
                                if (id_confiserie_unit[id_deducted]) {
                                    id_confiserie_unit[id_deducted].qty += product_deducted[i].qty;
                                }
                            }
                        }

                        // console.log("sorted_menu", sorted_menu[sm])
                        // console.log("menu ok", menu_ok)
                        // console.log("tab_compo_my_menu", tab_compo_my_menu)
                        // console.log("at_least_one_menu", at_least_one_menu)
                    }
                } while (at_least_one_menu === true && nb < 10);
            }

            $.each(id_confiserie_unit, function (k, v) {
                var id_product = v.id;
                var qty_product = v.qty;

                if (qty_product > 0) {
                    var item_type = "product";

                    let data = {};
                    var data_item = v;
                    data_item.item_type = "product";

                    data_basket.nb_item_total += qty_product;

                    if (!(data_basket.confiserie[item_type])) {
                        data_basket.confiserie[item_type] = {};
                    }

                    if (!(data_basket.confiserie[item_type][data_item.id])) {
                        data_basket.confiserie[item_type][data_item.id] = {};

                        data_basket.confiserie[item_type][data_item.id].id = data_item.id;
                        data_basket.confiserie[item_type][data_item.id].qte = data_item.qty;
                        data_basket.confiserie[item_type][data_item.id].label = data_item.label;
                        data_basket.confiserie[item_type][data_item.id].price = data_item.price;
                        data_basket.confiserie[item_type][data_item.id].associated_price = data_item.associated_price;
                        data_basket.confiserie[item_type][data_item.id].is_sold_out = data_item.is_sold_out;
                    }
                }
            });

            gl_app.EMSBasket.update_basket(data_basket);

            gl_app.EMSBasket.end_process(); 
        }
    }

    select_item_in_menu(parameter) {
        // console.log("select_item_in_menu", parameter)

        const self = this;
        var elem_clicked = parameter.elem_from;
        var data_item_choosen = parameter.data_item;
        var data_confiserie_cinema = this.data_confiserie;

        if(!elem_clicked.hasClass("opacity-0-5")){
            var id_item_choosen=data_item_choosen.id;
            var id_menu=this.my_menu_to_compose.data.id;
            var indice=elem_clicked.data("indice");
            var that_class="menu_product_"+indice;
            var qty_max=this.my_menu_to_compose.data.products[indice].qty; // quantité max par slider de produits du menu
            var nb_item_choosen=0;

            // ===== On cherche le nombre d'item déjà ajouté pour cet id =====
            for(var q=0;q<this.my_menu_to_compose.tab_item_choosen.length;q++){
                if(this.my_menu_to_compose.tab_item_choosen[q]==id_item_choosen){
                    nb_item_choosen++;
                }
            }

            // ===== On vérifie également la liste des items pour ce slider (indice) afin de voir si un autre article que celui sélectionné à l'instant a déjà été ajouté =====
            $.each(data_confiserie_cinema.menus,function(key,value){
                if(id_menu==key){
                    var list_ids=value.products[indice].ids;
                    for(var q=0;q<self.my_menu_to_compose.tab_item_choosen.length;q++){
                        if((self.my_menu_to_compose.tab_item_choosen[q]!=id_item_choosen) && list_ids.indexOf(self.my_menu_to_compose.tab_item_choosen[q])>=0){
                            nb_item_choosen++;
                        }
                    }
                    return false; // arrête la boucle
                }
            });

            // ===== Si on peut encore ajouté cet article =====
            if(nb_item_choosen<qty_max){
                this.my_menu_to_compose.tab_item_choosen.push(id_item_choosen);
                nb_item_choosen++;
                this.my_menu_to_compose.nb_item_tot_selected++;
                
                // ===== Recherche des infos du produits =====
                $.each(data_confiserie_cinema.products,function(key,value){
                    if(id_item_choosen==key){
                        var $row_selection_item_menu=$("<div/>").addClass("row row_recap_selected_item m-0 py-1 py-xl-2").appendTo($("#col_recap_selection"));
                            var $col_selection_item_menu=$("<div/>").addClass("col-12 p-0 d-flex position-relative").appendTo($row_selection_item_menu);
                                var $label_item=$("<div/>").addClass("label ps-3 my-auto").text("- "+value.label).appendTo($col_selection_item_menu);

                                var $svg_container = $("<div/>").addClass("svg_container icon icon_svg ms-auto me-3").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_trash")[0].svg_text).data({"id":id_item_choosen,"that_class":that_class,"parent":$row_selection_item_menu}).appendTo($col_selection_item_menu).on("click",function() {
                                    var $t=$(this);
                                    var id_item_to_delete=$t.data("id");
                                    for(var q=0;q<self.my_menu_to_compose.tab_item_choosen.length;q++){
                                        if(self.my_menu_to_compose.tab_item_choosen[q]==id_item_to_delete){
                                            self.my_menu_to_compose.tab_item_choosen.splice(q,1);
                                            
                                            $("."+$t.data("that_class")).each(function(){
                                                $(this).removeClass("opacity-0-5")
                                            });
                                            break;
                                        }
                                    }
                                    
                                    self.my_menu_to_compose.nb_item_tot_selected--;
                                    
                                    $(".btn_confirm_compo_menu").addClass("hide");
                                    $(".btn_confirm_compo_menu").addClass("disabled");
                                    
                                    // ===== Suppression de la ligne sur le récap de la sélection =====
                                    $t.data("parent").remove();
                                })

                        return false; // arrête la boucle
                    }
                });
            }

            // ===== Si on a atteint la qte max, on rends inactif toute la liste de ce slider =====
            if(nb_item_choosen==qty_max){
                $("."+that_class).each(function(){
                    $(this).addClass("opacity-0-5");
                });
                // ===== On scroll au slide suivant automatiquement =====
                if($("#row_choice_menu_"+id_menu+"_"+(indice+1)).length>0){
                    $(".modal-body").animate({"scrollTop":$("#row_choice_menu_"+id_menu+"_"+(indice+1))[0].offsetTop},250);
                }
            }

            // ===== Si tous les articles sont sélectionnés, on rends actif le bouton "valider" =====
            if(this.my_menu_to_compose.nb_item_tot_selected==this.my_menu_to_compose.nb_item_tot_to_choose){
                $(".btn_confirm_compo_menu").removeClass("hide");
                $(".btn_confirm_compo_menu").removeClass("disabled");
            }
        }
    }
}